<script>
  import { M } from '../../external';
  import SubscriptionsTable from '../../Store/Subscriptions/SubscriptionsTable.svelte';

  export let contact;

  let tab = 'active';
</script>

<ul class="upper-navigation upper-navigation-full mb-15">
  <li><a class:active={tab === "active"} on:click|preventDefault={() => tab = 'active'}>{M.ACTIVE}</a></li>
  <li><a class:active={tab === "churn"} on:click|preventDefault={() => tab = 'churn'}>{M.CHURN_LBL}</a></li>
</ul>

{#if tab === "active"}
  <SubscriptionsTable contact={contact.id} />
{:else if tab === "churn"}
  <SubscriptionsTable contact={contact.id} showArchived={true} />
{/if}
